var map = {
	"./button.svg": "9PWN",
	"./calendar.svg": "F19i",
	"./check-circle.svg": "o892",
	"./create.svg": "SqcE",
	"./detail.svg": "LkfP",
	"./export.svg": "I2ED",
	"./import.svg": "XU5j",
	"./info.svg": "9N/g",
	"./list.svg": "+PR7",
	"./reset.svg": "lELM",
	"./script-action.svg": "GLAG",
	"./table.svg": "Y2vR"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cyQb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new-form-ui/icon ^\.\/.*\.svg$
// module id = cyQb
// module chunks = 46